import LeadQualificationPage from './LeadQualificationPage'

export default LeadQualificationPage
